// Console.jsx
// TK 7/25/2k22

// Packages, dependencies, and library functions
import React, { useState, useEffect } from "react";
import { auth } from "../Firebase";
import { onAuthStateChanged } from "firebase/auth";
import { Route, Routes } from "react-router-dom";

// React Components
import Login from "./Login/Login";
import ConsoleHome from "./Home/ConsoleHome";
import PlantEditor from "./PlantEditor/PlantEditor";
import PlantGeneration from "./PlantGeneration/PlantGeneration";
import TagGeneration from "./TagGeneration/TagGeneration";
import Analytics from "./Analytics/Analytics";
import CareInstructionsUpload from "./CareInstructionsUpload/CareInstructionsUpload";
import StagesUpload from "./SpeciesInfoUpload/SpeciesInfoUpload";
import SpeciesTraitsUpload from "./SpeciesTraitsUpload/SpeciesTraitsUpload";
import PlantWaterReset from "./PlantWaterReset/PlantWaterReset";
import SpeciesRegeneration from "./SpeciesRegeneration/SpeciesRegeneration";
import UserPlants from "./UserPlants/UserPlants";
import SpriteUpload from "./SpriteUpload";
import SpeciesOwnerCounts from "./SpeciesOwnerCounts/SpeciesOwnerCounts";
import ConsoleAnalyticsV2 from "./AnalyticsV2/pages/ConsoleAnalyticsV2";
import ChatV2Tester from "./ChatV2Tester/ChatV2Tester";
import Snailsforce from "./Snailsforce/Snailsforce";
import CampaignAnalytics from "./CampaignAnalytics/CampaignAnalytics";
import PromoTagGeneration from "./PromoTagGeneration/PromoTagGeneration";
import ConversationViewer from "./ConversationViewer/ConversationViewer";
import ConsoleV2 from "./ConsoleV2/ConsoleV2";

import PageNotFound from "../MiscPages/PageNotFound";

// CSS
// import "../App.css";

const Console = () => {
  // Hooks
  const [user, setUser] = useState({});

  // Wait/get the auth state
  useEffect(() => {
    authListener();
  }, []);

  // Listen for the auth state to change to fire a re-render of the home
  const authListener = () => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });
  };

  return (
    <React.Fragment>
      {user ? (
        <Routes>
          {/* List Valid Routes here */}
          <Route path="/" element={<ConsoleHome />} />
          <Route path="planteditor" element={<PlantEditor />} />
          <Route path="plantgeneration" element={<PlantGeneration />} />
          <Route path="taggeneration" element={<TagGeneration />} />
          <Route path="promotags" element={<PromoTagGeneration />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="analyticsv2" element={<ConsoleAnalyticsV2 />} />
          <Route path="campaigns" element={<CampaignAnalytics />} />
          <Route
            path="careinstructionsupload"
            element={<CareInstructionsUpload />}
          />
          <Route path="speciesinfoupload" element={<StagesUpload />} />
          <Route path="speciestraitsupload" element={<SpeciesTraitsUpload />} />
          <Route path="plantwaterreset" element={<PlantWaterReset />} />
          <Route path="speciesregeneration" element={<SpeciesRegeneration />} />
          <Route path="userplants" element={<UserPlants />} />
          <Route path="speciesownercounts" element={<SpeciesOwnerCounts />} />
          <Route path="spriteupload" element={<SpriteUpload />} />
          <Route path="chatv2tester" element={<ChatV2Tester />} />
          <Route path="snailsforce" element={<Snailsforce />} />
          <Route path="conversations" element={<ConversationViewer />} />
          <Route path="v2" element={<ConsoleV2 />} />
          {/* No Match Case */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      ) : (
        <Login />
      )}
    </React.Fragment>
  );
};

export default Console;
